import {REFRESH_REPORTS_LIST, CHANGE_SUC_SHOW} from '../actions/reportList';

const initState = {
  reports: {
    data: null
  },
  sucShow: true
};


export default (state = initState, action) => {
  switch (action.type) {
    case REFRESH_REPORTS_LIST: {
      const {reportsData} = action;
      return Object.assign({}, state, {
        reports: Object.assign({}, state.reports, {
          data: reportsData
        })
      });
    }
    case CHANGE_SUC_SHOW: {
      return Object.assign({}, state, {
        sucShow: false
      });
    }
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/reportList.js